module.exports = __webpack_public_path__ + "img/button-mewconnect.067426be.svg";